<!-- Modal Header -->
@if (modal_name) {
<div class="modal-header">
  <h3 class="modal-title">{{ modalTitle }}</h3>
  <div class="header-actions">
    <i class="fa" 
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px; cursor: pointer;" 
       (click)="minimise = !minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>
}

<!-- Modal Body -->
<div class="modal-body" [ngClass]="{'no-body-scroll': modal_name}" [hidden]="minimise">
  
  <!-- Loading Spinner -->
  @if (showFormLoader) {
<div class="loading-container">
    <i class="fa fa-spinner fa-spin fa-3x"></i>
  </div>
}

  @if (!showFormLoader) {
<div>
    <!-- Beginning/Ending Period -->
    <div class="row">
      <div class="col-md-6">
        <div class="row">
          <label class="col-md-6">Beginning period (MM/DD/YYYY):</label>
          <div class="col-md-4">
            <input type="date" class="form-control" 
                   [ngModel]="formatDateForInput(attribData['8865_NA_PTSP_BEGIN_DATE'])"
                   (ngModelChange)="onDateChange($event, '8865_NA_PTSP_BEGIN_DATE', 'override')">
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="row">
          <label class="col-md-6">Ending period (MM/DD/YYYY):</label>
          <div class="col-md-4">
            <input type="date" class="form-control" 
                   [ngModel]="formatDateForInput(attribData['8865_NA_PTSP_END_DATE'])"
                   (ngModelChange)="onDateChange($event, '8865_NA_PTSP_END_DATE', 'override')">
          </div>
        </div>
      </div>
    </div>

    <!-- Filing Group -->
    <div class="row">
      <label class="col-md-6">Filing Group</label>
      <div class="col-md-6">
        <select class="form-control" [(ngModel)]="selectedGroup" 
                (ngModelChange)="onFilingGroupChange($event)">
          <option [ngValue]="null">Select Filing Group</option>
          @for (fg of filingGroup; track $index) {
<option [ngValue]="fg">
            {{ fg.LEGAL_ENTITY_NAME }}
          </option>
}
        </select>
      </div>
    </div>

    <!-- Name and Filer's Identifying Number -->
    <div class="row">
      <div class="col-md-6">
        <label>Name of person filing this return:</label>
        <div>{{ selectedGroup?.LEGAL_ENTITY_NAME }}</div>
      </div>
      <div class="col-md-6">
        <div class="pull-left">
          Filer's Identifying Number
          <br>{{ selectedGroup?.FILER_EIN || '' }}
        </div>
      </div>
    </div>

    <!-- Address -->
    <div class="row">
      <div class="col-md-6">
        <label>Number, Street and Room or Suite No.</label>
        <div>{{ selectedGroup?.REG_ADDRESS_LINE1_8865 }}&emsp;{{ selectedGroup?.REG_ADDRESS_LINE2_8865 }}</div>
      </div>
      <div class="col-md-6">
        <div class="pull-left">
          City or Town, State and Zip code
          <br>{{ selectedGroup?.REG_ADDRESS_CITY }}&emsp;{{ selectedGroup?.REG_ADDRESS_STATE }}&emsp;{{ selectedGroup?.REG_ADDRESS_ZIP }}
        </div>
      </div>
    </div>

    <!-- Section A - Category of Filer -->
    <div class="row">
      <div class="col-md-12">
        <label class="pull-left"><b>A.</b>&emsp;</label>
        <div class="pull-left">
          <span>Category of filer (See Categories of Filers in the instructions and Check applicable box(es)):</span>
          <div class="checkbox-row">
            <span class="checkbox-item">
              1 <input type="checkbox" [(ngModel)]="checkBoxb1" 
                       (change)="set_override_flag(checkBoxb1, '8865_NA_A_1_Y')">
            </span>
            <span class="checkbox-item">
              2 <input type="checkbox" [(ngModel)]="checkBoxb3" 
                       (change)="set_override_flag(checkBoxb3, '8865_NA_A_2_Y')">
            </span>
            <span class="checkbox-item">
              3 <input type="checkbox" [(ngModel)]="checkBoxb4" 
                       (change)="set_override_flag(checkBoxb4, '8865_NA_A_3_Y')">
            </span>
            <span class="checkbox-item">
              4 <input type="checkbox" [(ngModel)]="checkBoxb5" 
                       (change)="set_override_flag(checkBoxb5, '8865_NA_A_4_Y')">
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Section B - Filer's Tax Year -->
    <div class="row">
      <div class="col-md-12">
        <label class="pull-left"><b>B.</b>&emsp;</label>
        <b>Filer's tax year</b>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3">
        <label>Beginning period (MM/DD/YYYY):</label>
      </div>
      <div class="col-md-3">{{ formatDate(selectedGroup?.FILER_TAX_YEAR_BEGIN) }}</div>
      <div class="col-md-3">
        <label>Ending period (MM/DD/YYYY):</label>
      </div>
      <div class="col-md-3">{{ formatDate(selectedGroup?.FILER_TAX_YEAR_END) }}</div>
    </div>

    <!-- Section C - Filer's share of liabilities -->
    <div class="row">
      <div class="col-md-6">
        <label class="pull-left"><b>C.</b>&emsp;</label>
        <b>Filer's share of liabilities:</b>
      </div>
      <div class="col-md-6">
        <div class="row">
          <label class="col-md-6">Nonrecourse $</label>
          <div class="col-md-6">
            <input type="text" class="form-control text-right" 
                   onlyIntegersWithLength
                   [(ngModel)]="attribData['8865_NA_C_NONRECOURSE']"
                   (change)="setOverridesFlag(attribData['8865_NA_C_NONRECOURSE'], '8865_NA_C_NONRECOURSE', 'text')">
          </div>
        </div>
        <div class="row">
          <label class="col-md-6">Qualified nonrecourse $</label>
          <div class="col-md-6">
            <input type="text" class="form-control text-right" 
                   onlyIntegersWithLength
                   [(ngModel)]="attribData['8865_NA_C_FINANCING']"
                   (change)="setOverridesFlag(attribData['8865_NA_C_FINANCING'], '8865_NA_C_FINANCING', 'text')">
          </div>
        </div>
        <div class="row">
          <label class="col-md-6">Other $</label>
          <div class="col-md-6">
            <input type="text" class="form-control text-right" 
                   onlyIntegersWithLength
                   [(ngModel)]="attribData['8865_NA_C_OTHER']"
                   (change)="setOverridesFlag(attribData['8865_NA_C_OTHER'], '8865_NA_C_OTHER', 'text')">
          </div>
        </div>
      </div>
    </div>

    <!-- Section F - Information about other partners -->
    <div class="row">
      <div class="col-md-6">
        <b>F.</b>&emsp;Information about certain other partners
      </div>
      <div class="col-md-6">
        <select class="form-control" [(ngModel)]="otherPartner" 
                (change)="selected1(otherPartner?.LE_KEY)">
          <option [ngValue]="null">Select Partner Details..</option>
          @for (partner of partnerDetails; track $index) {
<option [ngValue]="partner">
            {{ partner.PARTNER_DESC }}
          </option>
}
        </select>
      </div>
    </div>

    <!-- Section F4 - Partner Categories -->
    <div class="row">
      <div class="col-md-12">
        <label class="pull-left"><b>F</b>&emsp;4.&emsp;</label>
        <div class="pull-left">
          <span>Check applicable box(es):</span>
          <div class="checkbox-row">
            <span class="checkbox-item">
              Category 1 <input type="checkbox" [(ngModel)]="checkCatg1" 
                                (change)="set_override_flag(checkCatg1, '8865_NA_PARTNER_CATG_1_Y')">
            </span>
            <span class="checkbox-item">
              Category 2 <input type="checkbox" [(ngModel)]="checkCatg2" 
                                (change)="set_override_flag(checkCatg2, '8865_NA_PARTNER_CATG_2_Y')">
            </span>
            <span class="checkbox-item">
              Constructive Owner <input type="checkbox" [(ngModel)]="checkConstOwner" 
                                        (change)="set_override_flag(checkConstOwner, '8865_NA_PARTNER_CONSTRUCTIVE_OWNER_Y')">
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Section G - Foreign Partnership Info -->
    <div class="row">
      <div class="col-md-6">
        <b>G.&emsp;1.&emsp;</b>Name of foreign partnership
      </div>
      <div class="col-md-6">
        <input class="form-control" type="text" 
               [(ngModel)]="attribData['8865_NA_PTSP_NAME_1']" disabled>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <b>&emsp;&emsp;&emsp;&emsp;</b>Address of foreign partnership
      </div>
    </div>

    <!-- Country -->
    <div class="row">
      <div class="col-md-6">
        <b>&emsp;&emsp;&emsp;&emsp;</b>Country
      </div>
      <div class="col-md-6">
        <select class="form-control" [(ngModel)]="countryVar" disabled>
          <option value="">Select Country</option>
          @for (country of countries; track $index) {
<option [value]="country.COUNTRY_CODE">
            {{ country.COUNTRY_CODE }} - {{ country.COUNTRY_NAME }}
          </option>
}
        </select>
      </div>
    </div>

    <!-- Address Line 1 -->
    <div class="row">
      <div class="col-md-6">
        <b>&emsp;&emsp;&emsp;&emsp;</b>Line 1:
      </div>
      <div class="col-md-6">
        @if (!isUSCountry('var')) {
<input type="text" class="form-control"
               [(ngModel)]="attribData['8865_NA_PTSP_F_ADDR_1']" disabled>
}
        @if (isUSCountry('var')) {
<input type="text" class="form-control"
               [(ngModel)]="attribData['8865_NA_PTSP_US_ADDR_1']" disabled>
}
      </div>
    </div>

    <!-- Address Line 2 -->
    <div class="row">
      <div class="col-md-6">
        <b>&emsp;&emsp;&emsp;&emsp;</b>Line 2:
      </div>
      <div class="col-md-6">
        @if (!isUSCountry('var')) {
<input type="text" class="form-control"
               [(ngModel)]="attribData['8865_NA_PTSP_F_ADDR_2']" disabled>
}
        @if (isUSCountry('var')) {
<input type="text" class="form-control"
               [(ngModel)]="attribData['8865_NA_PTSP_US_ADDR_2']" disabled>
}
      </div>
    </div>

    <!-- City -->
    <div class="row">
      <div class="col-md-6">
        <b>&emsp;&emsp;&emsp;&emsp;</b>City:
      </div>
      <div class="col-md-6">
        @if (!isUSCountry('var')) {
<input type="text" class="form-control"
               [(ngModel)]="attribData['8865_NA_PTSP_F_CITY']" disabled>
}
        @if (isUSCountry('var')) {
<input type="text" class="form-control"
               [(ngModel)]="attribData['8865_NA_PTSP_US_CITY']" disabled>
}
      </div>
    </div>

    <!-- State -->
    <div class="row">
      <div class="col-md-6">
        <b>&emsp;&emsp;&emsp;&emsp;</b>State:
      </div>
      <div class="col-md-6">
        @if (isUSCountry('var')) {
<select class="form-control"
                [(ngModel)]="attribData['8865_NA_PTSP_US_STATE']" disabled>
          <option value="">Select State</option>
          @for (state of states; track $index) {
<option [value]="state.CODE">
            {{ state.CODE }} - {{ state.NAME }}
          </option>
}
        </select>
}
        @if (!isUSCountry('var')) {
<input type="text" class="form-control"
               [(ngModel)]="attribData['8865_NA_PTSP_F_STATE']" disabled>
}
      </div>
    </div>

    <!-- Zip -->
    <div class="row">
      <div class="col-md-6">
        <b>&emsp;&emsp;&emsp;&emsp;</b>Zip/Postal Code:
      </div>
      <div class="col-md-6">
        @if (!isUSCountry('var')) {
<input type="text" class="form-control"
               [(ngModel)]="attribData['8865_NA_PTSP_F_ZIP']" disabled>
}
        @if (isUSCountry('var')) {
<input type="text" class="form-control"
               [(ngModel)]="attribData['8865_NA_PTSP_US_ZIP']" disabled>
}
      </div>
    </div>

    <!-- G2a - Identifying Number (format: XX-XXXXXXX) -->
    <div class="row">
      <div class="col-md-6">
        <b>&emsp;&emsp;2(a).&emsp;</b>Identifying number (if any)
      </div>
      <div class="col-md-6">
        <div class="row identifying-row">
          <div class="col-md-4">
            <input class="form-control" type="text" maxlength="10"
                   [value]="getFormattedEIN('8865_NA_PTSP_EIN')"
                   (input)="formatEIN('8865_NA_PTSP_EIN', $event)"
                   (change)="uncheckedRadio(attribData['8865_NA_PTSP_EIN'], 'F8865_NA_PTSP_EIN')">
          </div>
          <div class="col-md-4">
            <label>
              <input type="radio" name="identify" value="APPLD FOR" 
                     [(ngModel)]="attribData['8865_NA_PTSP_EIN_MISSING_REASON']"
                     (click)="radioClicked(attribData['8865_NA_PTSP_EIN_MISSING_REASON'], 'F8865_NA_PTSP_EIN_MISSING_REASON')"> Applied For
            </label>
          </div>
          <div class="col-md-4">
            <label>
              <input type="radio" name="identify" value="FOREIGNUS" 
                     [(ngModel)]="attribData['8865_NA_PTSP_EIN_MISSING_REASON']"
                     (click)="radioClicked(attribData['8865_NA_PTSP_EIN_MISSING_REASON'], 'F8865_NA_PTSP_EIN_MISSING_REASON')"> Not Applicable
            </label>
          </div>
        </div>
      </div>
    </div>

    <!-- G2b - Reference ID -->
    <div class="row">
      <div class="col-md-6">
        <b>&emsp;&emsp;2(b).&emsp;</b>Reference ID number (see instructions)
      </div>
      <div class="col-md-6">
        <input type="text" class="form-control" [(ngModel)]="attribData['8865_NA_G2_REF_ID']"
               (change)="setOverridesFlag(attribData['8865_NA_G2_REF_ID'], '8865_NA_G2_REF_ID', 'text')">
      </div>
    </div>

    <!-- G3 - Country Laws -->
    <div class="row">
      <div class="col-md-6">
        <b>&emsp;&emsp;3.&emsp;</b>Country under whose laws organized
      </div>
      <div class="col-md-6">
        <select class="form-control" [(ngModel)]="attribData['8865_NA_G3_COUNTRY']"
                (change)="changeCountryLaws(attribData['8865_NA_G3_COUNTRY'], 'F8865_NA_G3_COUNTRY')">
          <option value="">Select Country</option>
          @for (country of countries; track $index) {
<option [value]="country.COUNTRY_CODE">
            {{ country.COUNTRY_CODE }} - {{ country.COUNTRY_NAME }}
          </option>
}
        </select>
      </div>
    </div>

    <!-- G4 - Date of Organization -->
    <div class="row">
      <div class="col-md-6">
        <b>&emsp;&emsp;4.&emsp;</b>Date of organization (MM/DD/YYYY)
      </div>
      <div class="col-md-6">
        <input type="date" class="form-control" 
               [ngModel]="formatDateForInput(attribData['8865_NA_G4_DATE'])"
               (ngModelChange)="onDateChange($event, '8865_NA_G4_DATE', 'set')">
      </div>
    </div>

    <!-- G5 - Principal Place of Business -->
    <div class="row">
      <div class="col-md-6">
        <b>&emsp;&emsp;5.&emsp;</b>Principal place of business
      </div>
      <div class="col-md-6">
        <select class="form-control" [(ngModel)]="attribData['8865_NA_G5_PRIPL_PLACE']"
                (change)="set_override_flag(attribData['8865_NA_G5_PRIPL_PLACE'], 'F8865_NA_G5_PRIPL_PLACE')">
          <option value="">Select Country</option>
          @for (country of countries; track $index) {
<option [value]="country.COUNTRY_CODE">
            {{ country.COUNTRY_CODE }} - {{ country.COUNTRY_NAME }}
          </option>
}
        </select>
      </div>
    </div>

    <!-- G6 - Principal Business Activity Code -->
    <div class="row">
      <div class="col-md-6">
        <b>&emsp;&emsp;6.&emsp;</b>Principal business activity code number
      </div>
      <div class="col-md-6">
        <select class="form-control" [(ngModel)]="selectedGroup1"
                (ngModelChange)="onPBAChange($event)">
          <option [ngValue]="null">Select Principal Business Activity</option>
          @for (pba of PrincipalBusinessActivity; track $index) {
<option [ngValue]="pba">
            {{ pba.ACTIVITY_CODE }}
          </option>
}
        </select>
      </div>
    </div>

    <!-- G7 - Principal Business Activity -->
    <div class="row">
      <div class="col-md-6">
        <b>&emsp;&emsp;7.&emsp;</b>Principal business activity
      </div>
      <div class="col-md-6">
        {{ selectedGroup1?.ACTIVITY_DESC }}
      </div>
    </div>

    <!-- G8a - Functional Currency -->
    <div class="row">
      <div class="col-md-6">
        <b>&emsp;&emsp;8a.&emsp;</b>Functional currency
      </div>
      <div class="col-md-6">
        <select class="form-control" [(ngModel)]="attribData['8865_NA_G8_FUNC_CURR']"
                (change)="updateWeightedAverage(attribData['8865_NA_G8_FUNC_CURR'])" disabled>
          <option value="">Select Functional Currency</option>
          @for (curr of currencies; track $index) {
<option [value]="curr.CURR_CODE">
            {{ curr.CURR_CODE }} - {{ curr.CURR_DESC }}
          </option>
}
        </select>
      </div>
    </div>

    <!-- G8b - Weighted Average Exchange Rate -->
    <div class="row">
      <div class="col-md-6">
        <b>&emsp;&emsp;8b.&emsp;</b>Weighted Average exchange rate
      </div>
      <div class="col-md-6">
        <input type="text" class="form-control" 
               [(ngModel)]="attribData['8865_NA_G8_EXCH_RATE']" disabled>
      </div>
    </div>

    <!-- Section H2 - Forms to file -->
    <div class="row">
      <div class="col-md-6">
        <b>H.&emsp;2.&emsp;Check if the foreign partnership must file</b>
      </div>
      <div class="col-md-6">
        <div class="checkbox-row">
          <span class="checkbox-item">
            <input type="checkbox" [(ngModel)]="form_1042"
                   (change)="setOverridesFlag(form_1042, '8865_NA_F1042_Y', 'checkbox', '1042')">
            Form 1042
          </span>
          <span class="checkbox-item">
            <input type="checkbox" [(ngModel)]="form_8804"
                   (change)="setOverridesFlag(form_8804, '8865_NA_F8804_Y', 'checkbox', '8804')">
            Form 8804
          </span>
          <span class="checkbox-item">
            <input type="checkbox" [(ngModel)]="form_1065"
                   (change)="setOverridesFlag(form_1065, '8865_NA_F1065_Y', 'checkbox', '1065')">
            Form 1065 or 1065-B
          </span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6"></div>
      <div class="col-md-6">
        <b>Service center where Form 1065 or 1065-B is filed:</b>
        <p>Ogden, UT</p>
      </div>
    </div>

    <!-- Section H3 - Name and address of agent -->
    <div class="row">
      <div class="col-md-6">
        <b>H.&emsp;3.&emsp;</b>Name and address of foreign partnership's agent in country of organization, if any
      </div>
      <div class="col-md-6">
        <div class="checkbox-row">
          <span class="checkbox-item">
            <input type="radio" name="h3Type" value="P" [(ngModel)]="radioH3Type"
                   (change)="personBnssChangeAgent('P', '8865_NA_H3_FLAG', 'radio')"> Person
          </span>
          <span class="checkbox-item">
            <input type="radio" name="h3Type" value="B" [(ngModel)]="radioH3Type"
                   (change)="personBnssChangeAgent('B', '8865_NA_H3_FLAG', 'radio')"> Business
          </span>
          <span class="checkbox-item">
            <input type="radio" name="h3Type" value="N" [(ngModel)]="radioH3Type"
                   (change)="personBnssChangeAgent('N', '8865_NA_H3_FLAG', 'radio')"> Not Applicable
          </span>
        </div>
      </div>
    </div>

    <!-- H3 Address Fields -->
    <div class="row">
      <div class="col-md-6"><b>&emsp;&emsp;&emsp;&emsp;</b>Name Line 1:</div>
      <div class="col-md-6">
        <input type="text" class="form-control" [(ngModel)]="attribData['8865_NA_FPTSP_AGENT_NAME_1']"
               [disabled]="radioH3Type === 'N'">
      </div>
    </div>
    <div class="row">
      <div class="col-md-6"><b>&emsp;&emsp;&emsp;&emsp;</b>Name Line 2 (allowed only if name/address type is Business):</div>
      <div class="col-md-6">
        <input type="text" class="form-control" [(ngModel)]="attribData['8865_NA_FPTSP_AGENT_NAME_2']"
               [disabled]="radioH3Type !== 'B'">
      </div>
    </div>
    <div class="row">
      <div class="col-md-6"><b>&emsp;&emsp;&emsp;&emsp;</b>Country</div>
      <div class="col-md-6">
        <select class="form-control" [(ngModel)]="countryAgent"
                (change)="changeCountryAgent(countryAgent, '8865_NA_FPTSP_AGENT_F_COUNTRY', 'text')"
                [disabled]="radioH3Type === 'N'">
          <option value="">Select Country</option>
          @for (country of countries; track $index) {
<option [value]="country.COUNTRY_CODE">
            {{ country.COUNTRY_CODE }} - {{ country.COUNTRY_NAME }}
          </option>
}
        </select>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6"><b>&emsp;&emsp;&emsp;&emsp;</b>Address Line 1:</div>
      <div class="col-md-6">
        <input type="text" class="form-control" 
               [(ngModel)]="attribData[isUSCountry('agent') ? '8865_NA_FPTSP_AGENT_US_ADDR_1' : '8865_NA_FPTSP_AGENT_F_ADDR_1']"
               [disabled]="radioH3Type === 'N'">
      </div>
    </div>
    <div class="row">
      <div class="col-md-6"><b>&emsp;&emsp;&emsp;&emsp;</b>Address Line 2:</div>
      <div class="col-md-6">
        <input type="text" class="form-control" 
               [(ngModel)]="attribData[isUSCountry('agent') ? '8865_NA_FPTSP_AGENT_US_ADDR_2' : '8865_NA_FPTSP_AGENT_F_ADDR_2']"
               [disabled]="radioH3Type === 'N'">
      </div>
    </div>
    <div class="row">
      <div class="col-md-6"><b>&emsp;&emsp;&emsp;&emsp;</b>City:</div>
      <div class="col-md-6">
        <input type="text" class="form-control" 
               [(ngModel)]="attribData[isUSCountry('agent') ? '8865_NA_FPTSP_AGENT_US_CITY' : '8865_NA_FPTSP_AGENT_F_CITY']"
               [disabled]="radioH3Type === 'N'">
      </div>
    </div>
    <div class="row">
      <div class="col-md-6"><b>&emsp;&emsp;&emsp;&emsp;</b>State:</div>
      <div class="col-md-6">
        <input type="text" class="form-control" 
               [(ngModel)]="attribData[isUSCountry('agent') ? '8865_NA_FPTSP_AGENT_US_STATE' : '8865_NA_FPTSP_AGENT_F_STATE']"
               [disabled]="radioH3Type === 'N'">
      </div>
    </div>
    <div class="row">
      <div class="col-md-6"><b>&emsp;&emsp;&emsp;&emsp;</b>Zip/Postal Code:</div>
      <div class="col-md-6">
        <input type="text" class="form-control" 
               [(ngModel)]="attribData[isUSCountry('agent') ? '8865_NA_FPTSP_AGENT_US_ZIP' : '8865_NA_FPTSP_AGENT_F_ZIP']"
               [disabled]="radioH3Type === 'N'">
      </div>
    </div>

    <!-- Section H4 - Name and address of person with custody -->
    <div class="row">
      <div class="col-md-6">
        <b>H.&emsp;4.&emsp;</b>Name and address of person(s) with custody of the books and records of the foreign partnership, and the location of such books and records, if different
      </div>
      <div class="col-md-6">
        <div class="checkbox-row">
          <span class="checkbox-item">
            <input type="radio" name="h4Type" value="P" [(ngModel)]="radioH4Type"
                   (change)="personBnssChange('P', '8865_NA_H4_FLAG', 'radio')"> Person
          </span>
          <span class="checkbox-item">
            <input type="radio" name="h4Type" value="B" [(ngModel)]="radioH4Type"
                   (change)="personBnssChange('B', '8865_NA_H4_FLAG', 'radio')"> Business
          </span>
          <span class="checkbox-item">
            <input type="radio" name="h4Type" value="N" [(ngModel)]="radioH4Type"
                   (change)="personBnssChange('N', '8865_NA_H4_FLAG', 'radio')"> Not Applicable
          </span>
        </div>
      </div>
    </div>

    <!-- H4 Address Fields -->
    <div class="row">
      <div class="col-md-6"><b>&emsp;&emsp;&emsp;&emsp;</b>Name Line 1:</div>
      <div class="col-md-6">
        <input type="text" class="form-control" [(ngModel)]="attribData['8865_NA_PERSONS_BOOK_NAME_1']"
               [disabled]="radioH4Type === 'N'">
      </div>
    </div>
    <div class="row">
      <div class="col-md-6"><b>&emsp;&emsp;&emsp;&emsp;</b>Name Line 2 (allowed only if name/address type is Business):</div>
      <div class="col-md-6">
        <input type="text" class="form-control" [(ngModel)]="attribData['8865_NA_PERSONS_BOOK_NAME_2']"
               [disabled]="radioH4Type !== 'B'">
      </div>
    </div>
    <div class="row">
      <div class="col-md-6"><b>&emsp;&emsp;&emsp;&emsp;</b>Country</div>
      <div class="col-md-6">
        <select class="form-control" [(ngModel)]="countryCust"
                (change)="changeCountry(countryCust, '8865_NA_PERSONS_BOOK_F_COUNTRY', 'text')"
                [disabled]="radioH4Type === 'N'">
          <option value="">Select Country</option>
          @for (country of countries; track $index) {
<option [value]="country.COUNTRY_CODE">
            {{ country.COUNTRY_CODE }} - {{ country.COUNTRY_NAME }}
          </option>
}
        </select>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6"><b>&emsp;&emsp;&emsp;&emsp;</b>Address Line 1:</div>
      <div class="col-md-6">
        <input type="text" class="form-control" 
               [(ngModel)]="attribData[isUSCountry('cust') ? '8865_NA_PERSONS_BOOK_US_ADDR_1' : '8865_NA_PERSONS_BOOK_F_ADDR_1']"
               [disabled]="radioH4Type === 'N'">
      </div>
    </div>
    <div class="row">
      <div class="col-md-6"><b>&emsp;&emsp;&emsp;&emsp;</b>Address Line 2:</div>
      <div class="col-md-6">
        <input type="text" class="form-control" 
               [(ngModel)]="attribData[isUSCountry('cust') ? '8865_NA_PERSONS_BOOK_US_ADDR_2' : '8865_NA_PERSONS_BOOK_F_ADDR_2']"
               [disabled]="radioH4Type === 'N'">
      </div>
    </div>
    <div class="row">
      <div class="col-md-6"><b>&emsp;&emsp;&emsp;&emsp;</b>City:</div>
      <div class="col-md-6">
        <input type="text" class="form-control" 
               [(ngModel)]="attribData[isUSCountry('cust') ? '8865_NA_PERSONS_BOOK_US_CITY' : '8865_NA_PERSONS_BOOK_F_CITY']"
               [disabled]="radioH4Type === 'N'">
      </div>
    </div>
    <div class="row">
      <div class="col-md-6"><b>&emsp;&emsp;&emsp;&emsp;</b>State:</div>
      <div class="col-md-6">
        <input type="text" class="form-control" 
               [(ngModel)]="attribData[isUSCountry('cust') ? '8865_NA_PERSONS_BOOK_US_STATE' : '8865_NA_PERSONS_BOOK_F_STATE']"
               [disabled]="radioH4Type === 'N'">
      </div>
    </div>
    <div class="row">
      <div class="col-md-6"><b>&emsp;&emsp;&emsp;&emsp;</b>Zip/Postal Code:</div>
      <div class="col-md-6">
        <input type="text" class="form-control" 
               [(ngModel)]="attribData[isUSCountry('cust') ? '8865_NA_PERSONS_BOOK_US_ZIP' : '8865_NA_PERSONS_BOOK_F_ZIP']"
               [disabled]="radioH4Type === 'N'">
      </div>
    </div>

    <!-- H4 Identifying number (format: XX-XXXXXXX) -->
    <div class="row">
      <div class="col-md-6"><b>&emsp;&emsp;&emsp;&emsp;</b>Identifying number (if any)</div>
      <div class="col-md-6">
        <div class="row identifying-row">
          <div class="col-md-4">
            <input class="form-control" type="text" maxlength="10"
                   [value]="getFormattedEIN('8865_NA_H4_EIN_NUMBER')"
                   (input)="formatEIN('8865_NA_H4_EIN_NUMBER', $event)"
                   (change)="unchecked(attribData['8865_NA_H4_EIN_NUMBER'], 'F8865_NA_H4_EIN_NUMBER', 'text')"
                   [disabled]="radioH4Type === 'N'">
          </div>
          <div class="col-md-4">
            <label>
              <input type="radio" name="h4identify" value="APPLD FOR" 
                     [(ngModel)]="attribData['8865_NA_H4_EIN_MISSING_REASON']"
                     (click)="clicked(attribData['8865_NA_H4_EIN_MISSING_REASON'], 'F8865_NA_H4_EIN_MISSING_REASON', 'radio')"
                     [disabled]="radioH4Type === 'N'"> Applied For
            </label>
          </div>
          <div class="col-md-4">
            <label>
              <input type="radio" name="h4identify" value="FOREIGNUS" 
                     [(ngModel)]="attribData['8865_NA_H4_EIN_MISSING_REASON']"
                     (click)="clicked(attribData['8865_NA_H4_EIN_MISSING_REASON'], 'F8865_NA_H4_EIN_MISSING_REASON', 'radio')"
                     [disabled]="radioH4Type === 'N'"> Not Applicable
            </label>
          </div>
        </div>
      </div>
    </div>

    <!-- Schedule PG1 Data Table (Questions 5-15b) -->
    @if (schedulePG1Data.length > 0) {
<div class="form-horizontal">
      <table class="table table-bordered">
        <tbody>
          @for (row of schedulePG1Data; track $index; let i = $index) {
<tr>
            <td style="width: 5%;">{{ row.line_no }}.</td>
            @if (row.line_no !== '11') {
<td style="width: 75%;">
              {{ row.line_description }}
              @if (row.line_no === '5') {
<span><br>{{ row.line_description1 }}</span>
}
            </td>
}
            @if (row.line_no === '11') {
<td style="width: 75%;">
              @for (part of row.line_description?.split('+'); track $index; let last = $last) {
<span>
                {{ part }}@if (!last) {
<br>
}
              </span>
}
            </td>
}
            <td style="width: 20%;">
              <!-- Yes/No Radio Buttons - NOT shown for line 11 (line 11 only shows text) -->
              @if (row.propertyType === '13' && row.line_no !== '11') {
<div class="radio-group">
                <span class="radio-btn">
                  Yes <input type="radio" [value]="'Y'" 
                             [checked]="row.value[0]?.VALUE === 'Y'"
                             [name]="'row_' + i + '_yes'"
                             (change)="onRadioBtnSelection(row, i, 'Y')"
                             [disabled]="row.isEditableFlag === 'N'">
                </span>
                <span class="radio-btn">
                  No <input type="radio" [value]="'N'" 
                            [checked]="row.value[1]?.VALUE === 'N'"
                            [name]="'row_' + i + '_no'"
                            (change)="onRadioBtnSelection(row, i, 'N')"
                            [disabled]="row.isEditableFlag === 'N'">
                </span>
              </div>
}
              <!-- Text Input (propertyType 7) -->
              @if (row.propertyType === '7') {
<div>
                <input type="text" class="form-control text-right"
                       [(ngModel)]="row.value.VALUE"
                       [name]="'row_' + i + '_amt'"
                       [disabled]="row.isEditableFlag !== 'Y'"
                       (ngModelChange)="onPG1TextChange(row)">
              </div>
}
              <!-- Number Input with formatting (propertyType 9) -->
              @if (row.propertyType === '9') {
<div>
                <input type="text" class="form-control text-right"
                       onlyIntegersWithLength
                       [(ngModel)]="row.value.VALUE"
                       [name]="'row_' + i + '_amt'"
                       [disabled]="row.isEditableFlag !== 'Y'"
                       (ngModelChange)="onPG1TextChange(row)">
              </div>
}
              <!-- USD Input for line 5 with number formatting -->
              @if (row.line_no === '5' && row.value_1) {
<div class="input-group">
                <span class="input-group-addon">USD</span>
                <input type="text" class="form-control text-right"
                       onlyIntegersWithLength
                       [(ngModel)]="row.value_1.VALUE"
                       [name]="'row_' + i + '_usd'"
                       [disabled]="row.isEditableFlagText !== 'Y'"
                       (ngModelChange)="onPG1TextChange(row)">
              </div>
}
              <!-- Line 11 display - only text, no radio buttons (calculated from M2) -->
              @if (row.line_no === '11') {
<div class="text-center">
                {{ row.value[0]?.VALUE === 'Y' ? 'Yes' : (row.value[1]?.VALUE === 'N' ? 'No' : '') }}
              </div>
}
            </td>
          </tr>
}
        </tbody>
      </table>
    </div>
}

    <!-- Schedule O Section -->
    <div class="section-header">
      <b>Schedule O</b>
    </div>

    <div class="row">
      <div class="col-md-8">
        <b>&emsp;&emsp;1a.&emsp;</b>Is the partnership a section 721(c) partnership (as defined in Temporary Regulations section 1.721(c)-1T(b)(14))? See instructions
      </div>
      <div class="col-md-4">
        <div class="radio-group">
          <span class="radio-btn">
            Yes <input type="radio" name="schedO1a" value="Y" [(ngModel)]="radioBlk">
          </span>
          <span class="radio-btn">
            No <input type="radio" name="schedO1a" value="N" [(ngModel)]="radioBlk">
          </span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-8">
        <b>&emsp;&emsp;1b.&emsp;</b>If Yes, was the gain deferral method applied to avoid the recognition of gain upon the contribution of property?
      </div>
      <div class="col-md-4">
        <div class="radio-group">
          <span class="radio-btn">
            Yes <input type="radio" name="schedO1b" value="Y" [(ngModel)]="radioUnblk">
          </span>
          <span class="radio-btn">
            No <input type="radio" name="schedO1b" value="N" [(ngModel)]="radioUnblk">
          </span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-8">
        <b>&emsp;&emsp;2.&emsp;</b>Was any intangible property transferred considered or anticipated to be, at the time of the transfer or at any time thereafter, a platform contribution as defined in Regulations section 1.482-7(c)(1)?
      </div>
      <div class="col-md-4">
        <div class="radio-group">
          <span class="radio-btn">
            Yes <input type="radio" name="schedO2" value="Y" [(ngModel)]="radioUnblck">
          </span>
          <span class="radio-btn">
            No <input type="radio" name="schedO2" value="N" [(ngModel)]="radioUnblck">
          </span>
        </div>
      </div>
    </div>

  </div>
}
</div>

<!-- Modal Footer -->
@if (modal_name) {
<div class="modal-footer" [hidden]="minimise">
  <button class="btn btn-info btn-sm save-button" type="button" 
          (click)="saveScheduleGForm()" [disabled]="crudLoading">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
    Save and Proceed
  </button>
  <button class="btn btn-warning btn-sm cancel-button" type="button" (click)="cancel()">
    Cancel
  </button>
</div>
}
